import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ISpinnerState } from '@app/interfaces';

@Injectable({
    providedIn: 'root'
})
export class SpinnerService {
    public cb: any;
    private spinnerSubject: BehaviorSubject<ISpinnerState> = new BehaviorSubject<ISpinnerState>({ show: false, displayCancel: false });
    constructor() { }

    public show(displayCancel = false, cb): void {
        this.cb = cb;
        this.spinnerSubject.next(<ISpinnerState>{ show: true, displayCancel });
    }

    public hide(): void {
        this.spinnerSubject.next(<ISpinnerState>{ show: false, displayCancel: false });
    }

    public getSpinnerState(): Observable<ISpinnerState> {
        return this.spinnerSubject.asObservable();
    }
}
